import Vue from "vue";
import Vuex from "vuex";
import router from '../router/index.js'
const User = {
  namespaced: true,
  state: {
    users: [],
    userSelected: {
      email: null,
      password: null,
      password_confirm: null,
      phone: null,
      phoneIndicative: null,
      addressNum: null,
      addressExt: null,
      addressType: null,
      addressName: null,
      addressCity: null,
      addressPostalCode: null,
      isCorporation: false,
      nature: null,
      firstName: null,
      lastName: null,
      title: null,
      addressCountry: null,
      corporationName: null,
      corporationSiret: null,
      corporationAgent: null,
    },
    pagination: {},
    titles: [
      {
        value: "Monsieur",
        text: "M.",
      },
      {
        value: "Madame",
        text: "Mme",
      },
    ],
    natures: [
      {
        value: "Particulier",
        text: "Particulier",
      },
      {
        value: "Entreprise",
        text: "Entreprise",
      },
      {
        value: "Notaire",
        text: "Notaire",
      },
      {
        value: "Service public",
        text: "Service public",
      },
      {
        value: "Maitre",
        text: "Maître d'oeuvre ou conducteur d'opération",
      },
    ],
    natures_alignement: [
      {
        value: "Particulier",
        text: "Particulier",
      },
      {
        value: "Entreprise",
        text: "Entreprise",
      },
      {
        value: "Notaire",
        text: "Notaire",
      },
    ],
    natures_permission: [
      {
        value: "Particulier",
        text: "Particulier",
      },
      {
        value: "Entreprise",
        text: "Entreprise",
      },
      {
        value: "Service public",
        text: "Service public",
      },
      {
        value: "Notaire",
        text: "Notaire",
      },
      {
        value: "Maître d'ouvrage ou son représentant",
        text: "maître d'oeuvre ou conducteur d'opération",
      },
    ],
    natures_beneficiaire: [
      {
        value: "Particulier",
        text: "Particulier",
      },
      {
        value: "Entreprise",
        text: "Entreprise",
      },
      {
        value: "Service public",
        text: "Service public",
      },
      {
        value: "Maître d'oeuvre ou conducteur d'opération",
        text: "Maître d'oeuvre ou conducteur d'opération",
      },
    ],
  },
  actions: {
    setUser(context, user) {
      context.commit("GETUSER", user);
    },
    initUser(context) {
      return new Promise((resolve, reject) => {
        let user = {
          email: null,
          password: null,
          password_confirm: null,
          phone: null,
          phoneIndicative: null,
          addressNum: null,
          addressExt: null,
          addressType: null,
          addressName: null,
          addressCity: null,
          addressPostalCode: null,
          isCorporation: null,
          nature: null,
          firstName: null,
          lastName: null,
          title: null,
          addressCountry: null,
          corporationName: null,
          corporationSiret: null,
          corporationAgent: null,
          corporationAgentTitle: null,
        };
        context.commit("GETUSER", user);
        resolve();
      });
    },

    getUsers(context, pagination) {
      let page = "?page=" + pagination.page;

      let searchText = "&searchText=" + pagination.searchText;

      let searchFilter =
        "&searchFilter=" + JSON.stringify(pagination.searchFilter);

      let searchSort = "&searchSort=" + pagination.searchSort;
      let searchDir = "&searchDir=" + pagination.searchDir;

      Vue.axios
        .get(
          window.urlapi +
            "stduser" +
            page +
            searchText +
            searchFilter +
            searchSort +
            searchDir
        )
        .then((response) => {
          context.commit("GETUSERS", response.data.data);
          context.commit("SETPAGINATION", response.data.pagination);
        });
    },

    deleteUser(context, user) {
      Vue.axios
        .delete(window.urlapi + "stduser/" + user.id)
        .then((response) => {
          if (response.data.success == true) {
            Vue.prototype.$awn.success(response.data.message.toString());
            context.commit("REMOVEUSER", user);
          }
        });
    },
    updatePassword(context, user) {
      Vue.axios
        .put(window.urlapi + "user/" + user.id + "/password", user)
        .then((response) => {
          if (response.data.success == true) {
            Vue.prototype.$awn.success(response.data.message.toString());
            context.commit("GETUSER", response.data.data);
            if (
              user.password &&
              user.password != "secret" &&
              user.passwordConfirm
            ) {
              router.push({
                path: "/login",
              });
            }
          }
        });
    },

    checkAccount(context, token) {
      Vue.axios
        .put(window.urlapi + "user/validate-email/" + token)
        .then((response) => {
          if (response.data.success == true) {
            Vue.prototype.$awn.success(response.data.message.toString());
          }
        });
    },

    updateUser(context, user) {
      Vue.axios
        .put(window.urlapi + "stduser/" + user.id, user)
        .then((response) => {
          if (response.data.success == true) {
            Vue.prototype.$awn.success(response.data.message.toString());
            context.commit("GETUSER", response.data.data);
            if (
              user.password &&
              user.password != "secret" &&
              user.passwordConfirm
            ) {
              router.push({
                path: "/login",
              });
            }
          }
        });
    },

    addUser(context, user) {
      Vue.axios.post(window.urlapi + "register", user).then((response) => {
        if (response.data.success == true) {
          Vue.prototype.$awn.success(response.data.message.toString());
          router.push({
            name: "Users",
          });
        } else {
          Vue.prototype.$awn.errors(response.data.message.toString());
        }
      });
    },
    getUser(context, id) {
      return new Promise((resolve, reject) => {
        Vue.axios.get(window.urlapi + "stduser/" + id).then((response) => {
          context.commit("GETUSER", response.data.data);
          resolve();
        });
      });
    },
  },
  mutations: {
    SETPAGINATION: (state, pagination) => {
      state.pagination = pagination;
    },
    REMOVEUSER: (state, user) => {
      let index = state.users.findIndex((item) => item.id == user.id);
      state.users.splice(index, 1);
    },
    GETUSERS: (state, users) => {
      state.users = users;
    },
    GETUSER: (state, user) => {
      user.ticketOfficePerimeterId =
        user.ticketOfficePerimeter != null
          ? user.ticketOfficePerimeter.id
          : null;
      user.managerPerimeterId =
        user.managerPerimeter != null ? user.managerPerimeter.id : null;
      user.sousTraitantPerimeterId =
        user.sousTraitantPerimeter != null
          ? user.sousTraitantPerimeter.id
          : null;
      user.operatorPerimeterId =
        user.operatorPerimeter != null ? user.operatorPerimeter.id : null;
      user.managerPerimeter =
        user.managerPerimeter != null
          ? user.managerPerimeter
          : { id: null, type: null, libelle: null };
      state.userSelected = user;
    },
  },
  getters: {
    pagination: (state) => {
      return state.pagination;
    },
    natures: (state) => {
      return state.natures;
    },
    natures_alignement: (state) => {
      return state.natures_alignement;
    },
    natures_permission: (state) => {
      return state.natures_permission;
    },
    natures_beneficiaire: (state) => {
      return state.natures_beneficiaire;
    },
    titles: (state) => {
      return state.titles;
    },
    users: (state) => {
      return state.users;
    },
    userById: (state) => (id) => {
      let result = state.users.find((item) => item.id === id);
      return result;
    },
    countUsers: (state) => {
      return state.users.length;
    },
    userSelected: (state) => {
      return state.userSelected;
    },
  },
  modules: {},
};

export default User;